export default {
  autoInit: false,

  // Selectors
  selectorPopover: ".popover",
  selectorArrow: ".popover__arrow",

  // State classes
  stateActive: "is-active",

  // Feature settings
  eventListeners: true,
  eventType: "click",
  placement: "bottom"
};
